@let display = getCardDisplay();
<div class="card-number" [class.mobile-progress-enabled]="mobileProgressWindow()">
    <div class="desktop-progress d-flex align-items-center justify-content-start gap-14">
        <div class="all-number">
            <span>{{ display.current }}</span>
        </div>
        <div class="line-count"></div>
        <!-- На першій ітерації: два next елемента -->
        @if (display.isFirst) {
            <div class="d-flex align-items-center justify-content-center">
                <div class="num-card-now">
                    <svg class="svg-mobile-hide" xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#71C55D"><path d="m605-380 45-157-135-91-46 157 136 91ZM168-222l-29.91-15.45Q110-250 100-277q-10-27 2.7-54.85L168-472v250Zm148 78q-31.35 0-53.67-20.5Q240-185 240-216v-288l134 360h-58Zm206-4q-31 11-56-1t-36-43L259-660q-11-31 .5-56.5T302-753l294-107q31-11 56 .5t36 42.5l172 472q11 31-.5 56T817-253L522-148Zm-24-68 294-105-171-471-294 107 171 469Zm62-288Z"/></svg>
                    <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="3" cy="3" r="3" fill="#71C55D"/>
                    </svg>
                </div>
            </div>
            @if (display.current > 1) {
                <div class="d-flex align-items-center justify-content-center">
                    <div class="num-card-next">
                        <span> {{ display.current - 1 }}</span>
                    </div>
                </div>
            }
            @if (display.current > 2) {
                <div class="d-flex align-items-center justify-content-center">
                    <div class="num-card-next last">
                        <span> {{ display.current - 2 }}</span>
                    </div>
                </div>
            }
        }
        <!-- На останній ітерації: два prev елемента -->
        @if (display.isLast) {
            @if (display.current + 2 <= display.total) {
                <div class="d-flex align-items-center justify-content-center">
                    <div class="num-card-ready">
                        <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#71C55D"><path d="M389-267 195-460l51-52 143 143 325-324 51 51-376 375Z"/></svg>
                    </div>
                </div>
            }
            @if (display.current + 1 <= display.total) {
                <div class="d-flex align-items-center justify-content-center">
                    <div class="num-card-ready">
                        <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#71C55D"><path d="M389-267 195-460l51-52 143 143 325-324 51 51-376 375Z"/></svg>
                    </div>
                </div>
            }
            <div class="d-flex align-items-center justify-content-center">
                <div class="num-card-now">
                    <svg class="svg-mobile-hide" xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#71C55D"><path d="m605-380 45-157-135-91-46 157 136 91ZM168-222l-29.91-15.45Q110-250 100-277q-10-27 2.7-54.85L168-472v250Zm148 78q-31.35 0-53.67-20.5Q240-185 240-216v-288l134 360h-58Zm206-4q-31 11-56-1t-36-43L259-660q-11-31 .5-56.5T302-753l294-107q31-11 56 .5t36 42.5l172 472q11 31-.5 56T817-253L522-148Zm-24-68 294-105-171-471-294 107 171 469Zm62-288Z"/></svg>
                    <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="3" cy="3" r="3" fill="#71C55D"/>
                    </svg>
                </div>
            </div>
        }
        <!-- На середніх ітераціях: один prev, один active, один next -->
        @if (!display.isFirst && !display.isLast) {
            @if (display.prev) {
                <div class="d-flex align-items-center justify-content-center">
                    <div class="num-card-ready">
                        <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#71C55D"><path d="M389-267 195-460l51-52 143 143 325-324 51 51-376 375Z"/></svg>
                    </div>
                </div>
            }
            <div class="d-flex align-items-center justify-content-center">
                <div class="num-card-now">
                    <svg class="svg-mobile-hide" xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#71C55D"><path d="m605-380 45-157-135-91-46 157 136 91ZM168-222l-29.91-15.45Q110-250 100-277q-10-27 2.7-54.85L168-472v250Zm148 78q-31.35 0-53.67-20.5Q240-185 240-216v-288l134 360h-58Zm206-4q-31 11-56-1t-36-43L259-660q-11-31 .5-56.5T302-753l294-107q31-11 56 .5t36 42.5l172 472q11 31-.5 56T817-253L522-148Zm-24-68 294-105-171-471-294 107 171 469Zm62-288Z"/></svg>
                    <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="3" cy="3" r="3" fill="#71C55D"/>
                    </svg>
                </div>
            </div>
            @if (display.next) {
                <div class="d-flex align-items-center justify-content-center">
                    <div class="num-card-next last">
                        <span> {{ display.next }}</span>
                    </div>
                </div>
            }
        }
        
    </div>
    @if (mobileProgressWindow()) {
        <div class="mobile-progress d-flex align-items-center justify-content-start gap-14">
            <div class="all-number">
                <span>{{ display.current }}</span>
            </div>
            <div class="line-count"></div>
            @for (slot of display.mobileSlots; track slot.value) {
                <div class="d-flex align-items-center justify-content-center">
                    @if (slot.state === 'ready') {
                        <div class="num-card-ready">
                            <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#71C55D"><path d="M389-267 195-460l51-52 143 143 325-324 51 51-376 375Z"/></svg>
                        </div>
                    }
                    @if (slot.state === 'now') {
                        <div class="num-card-now">
                            <svg class="svg-mobile-hide" xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#71C55D"><path d="m605-380 45-157-135-91-46 157 136 91ZM168-222l-29.91-15.45Q110-250 100-277q-10-27 2.7-54.85L168-472v250Zm148 78q-31.35 0-53.67-20.5Q240-185 240-216v-288l134 360h-58Zm206-4q-31 11-56-1t-36-43L259-660q-11-31 .5-56.5T302-753l294-107q31-11 56 .5t36 42.5l172 472q11 31-.5 56T817-253L522-148Zm-24-68 294-105-171-471-294 107 171 469Zm62-288Z"/></svg>
                            <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="3" cy="3" r="3" fill="#71C55D"/>
                            </svg>
                        </div>
                    }
                    @if (slot.state === 'next') {
                        <div class="num-card-next" [class.last]="slot.isLast">
                            <span>{{ slot.value }}</span>
                        </div>
                    }
                </div>
            }
        </div>
    }
</div>